import { render, staticRenderFns } from "./myDialog.vue?vue&type=template&id=027cd759&scoped=true&"
import script from "./myDialog.vue?vue&type=script&lang=js&"
export * from "./myDialog.vue?vue&type=script&lang=js&"
import style0 from "./myDialog.vue?vue&type=style&index=0&id=027cd759&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027cd759",
  null
  
)

export default component.exports